import { moduleProviderFactory } from "core/providers";
import { NikoFacilityOrderClinicalReviewPreview, NikoDocumentationRequestEmailEdit } from "application/niko-facility-order-clinical-review/pages";
import { NikoInsuranceCoverageStatusOverviewEmailEdit } from "application/niko-insurance-coverage-status-overview/pages";

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: "master.app.main.niko-facility-order",
                pattern: "/niko-facility-orders",
                children: [
                    {
                        name: "master.app.main.niko-facility-order.clinical-review-preview",
                        pattern: "/:id/clinical-review",
                        authorization: "administrationSection.read",
                        component: NikoFacilityOrderClinicalReviewPreview,
                        data: {
                            //title: "",
                            crumbs: [
                                {
                                    title: "NIKO_FACILITY_ORDER.CRUMB.CLINICAL_REVIEW",
                                    route: 'master.app.main.niko-facility-order.clinical-review-preview'
                                }
                            ],
                            back: "master.app.main.niko-facility-order.list",
                        }
                    },
                    {
                        name: "master.app.main.niko-facility-order.niko-overview.new-flow-edit-email",
                        pattern: "/:facilityOrderId/new-flow/niko-overview-email",
                        component: NikoInsuranceCoverageStatusOverviewEmailEdit,
                        data: {
                            crumbs: [
                                {
                                    title: "NIKO_FACILITY_ORDER.CRUMB.CLINICAL_REVIEW",
                                    route: 'master.app.main.niko-facility-order.clinical-review-preview'
                                },
                                {
                                    title: "INSURANCE_COVERAGE_STATUS_OVERVIEW.TITLE",
                                    route: "master.app.main.niko-facility-order.niko-overview.new-flow-edit-email"
                                }
                            ]
                        }
                    },
                    {
                        name: "master.app.main.niko-facility-order.niko-documentation-request",
                        pattern: "/:facilityOrderId/niko-documentation-request",
                        component: NikoDocumentationRequestEmailEdit,
                        data: {
                            crumbs: [
                                {
                                    title: "NIKO_FACILITY_ORDER.CRUMB.CLINICAL_REVIEW",
                                    route: 'master.app.main.niko-facility-order.clinical-review-preview'
                                },
                                {
                                    title: "DOCUMENTATION_REQUEST.TITLE",
                                    route: 'master.app.main.niko-facility-order.niko-documentation-request'
                                }
                            ]
                        }
                    },
                ]
            }
        ],
        menu: [
            {
                title: "MENU.FACILITY_ORDERS",
                icon: "package",
                authorization: "administrationSection.read",
                order: 5,
                subMenu: [
                    {
                        title: "MENU.NIKO_FACILITY_ORDERS",
                        authorization: "administrationSection.read",
                        route: "master.app.main.niko-facility-order.list",
                        order: 3,
                    }
                ]
            },
        ]
    });
})();